import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import './style.css'


export default function ulasan() {
    return (
        <Container className="comp-ulasan">
            <Row>
                <Col md={8}>
                    <Row>
                        <Col md={6}>
                            <div className="ulasan-title">
                                <h6>Ulasan</h6>
                                <small>300 Ulasan</small>
                            </div>
                            <div className="ulasan-start">
                                <img src="asset/product/start.svg" alt="start" />
                                <h3>4.8 <small>/5.0</small></h3>          
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="ulasan-filter">
                                <p>Filter</p>
                                <button type="button">Semua Ulasan</button>
                                <div className="reting-ulasan">
                                    {
                                        Starts.map((item, i) => {
                                            return (
                                                <p key={i} className="start-border"><img src={item.icon} alt="start" /> {item.angka}</p>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className="retings">
                       <h6>{`Semau Ulasan (${RetingComent.length})`}</h6>
                        {
                            RetingComent.map((item, i) => {
                                return (
                                    <div key={i} className="ulasan-comentar">
                                        <img src={item.src} alt="image_coment" />
                                        <div className="comentar-content">
                                            <h6>{item.name}</h6>
                                            <div className="small">
                                                <small> <span>{item.tgl}</span> {item.product}</small>
                                                <div className="icon-Starts">
                                                    <img src="asset/product/start.svg" alt="start" />
                                                    <img src="asset/product/start.svg" alt="start" />
                                                    <img src="asset/product/start.svg" alt="start" />
                                                    <img src="asset/product/start.svg" alt="start" />
                                                    <img src={item.icon} alt="start" />
                                            </div>
                                            </div>
                                            <p>{item.coment}</p>
                                        </div>
                                </div>
                                )
                            })
                        }
                    </div>
                </Col>
            </Row>
            
        </Container>
    )
}

const Starts = [
    {angka:"5", icon:"asset/product/start.svg"},{angka:"4", icon:"asset/product/start.svg"},{angka:"3", icon:"asset/product/start.svg"},{angka:"2", icon:"asset/product/start.svg"},{angka:"1", icon:"asset/product/start.svg"}
]

const RetingComent =  [
    {src:"asset/product/image 14.png", tgl:"22-08-2021", product:"Hardcover", coment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim sem purus id posuere purus at turpis faucibus. Ac malesuada nullam tempor, vitae phasellus vitae fames. Vivamus scelerisque neque feugiat est nec commodo. Nullam est vitae sit scelerisque. Arcu morbi dolor amet, facilisi et. Sed consectetur sed adipiscing quis mollis ornare mauris, facilisis. Amet, non, tempus dolor facilisis urna amet. Sit tristique pretium est semper tempor convallis ultrices est, nibh.", name:"Fauzan", icon:"asset/product/start.svg"},
    {src:"asset/product/image 15.png", tgl:"23-08-2021", product:"Softcover", coment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim sem purus id posuere purus at turpis faucibus. Ac malesuada nullam tempor, vitae phasellus vitae fames. Vivamus scelerisque neque feugiat est nec commodo. Nullam est vitae sit scelerisque. Arcu morbi dolor amet, facilisi et. Sed consectetur sed adipiscing quis mollis ornare mauris, facilisis. Amet, non, tempus dolor facilisis urna amet. Sit tristique pretium est semper tempor convallis ultrices est, nibh.", name:"Abra", icon:"asset/product/bintang.svg"}
]
